import React, {useState} from 'react'
import {connect} from "react-redux";
import {Link} from 'react-router-dom'
import { CaretLeftOutlined, CaretRightOutlined, PoweroffOutlined, EditOutlined, BookOutlined,} from '@ant-design/icons';


import {routePath} from "../../../../router/paths"
import { Menu } from 'antd';
import jwtDecode from "jwt-decode";
import moment from "moment/moment";

const Sidebar = (props) => {
  const [collapsed, setCollapsed] = useState(true)
  const handleCollapse = () => {
    setCollapsed(!collapsed)
  };

  const TOKEN = localStorage.getItem("token");
  const info = jwtDecode(JSON.parse(TOKEN).access_token);

  const currentDate = moment().parseZone().format("YYYY-MM-DD");
  const kepExpiresDate = moment(info?.data?.idm?.notaryExpirationDate).parseZone().format("YYYY-MM-DD");
  console.log("kepExp", kepExpiresDate)
  const dateCompare = moment(currentDate).isBefore(kepExpiresDate)

  const handleLogout = (e) => {
    // localStorage.removeItem('token');
    // localStorage.removeItem('expires_in');
    // window.location.reload()
    props.history.push({
      pathname: routePath.DIGITAL_FRONT,
      state: {backPath: props.history.location.pathname}
    })
  };

  const {pathname} = props && props.history && props.history.location;

  return (
    <Menu id="navbar-right"
          theme="dark"
          selectedKeys={[pathname]}
          mode="inline"
          inlineIndent={12}
          inlineCollapsed={collapsed}
    >
      <Menu.Item key={1} onClick={handleCollapse} className='single-item link-main'>
        {
          collapsed ? <CaretLeftOutlined style={{color: "#ffffff", fontSize:"1rem"}} /> : <CaretRightOutlined style={{color: "#ffffff", fontSize:"1rem"}} />
        }
        <span style={{color:"#ffffff", fontWeight:"500"}}> {collapsed ? 'Розгорнути' : 'Згорнути'}</span>
      </Menu.Item>
      {info?.data?.idm?.isNotary && dateCompare &&
        <Menu.Item key={2} className='single-item link-main'>
        <Link to={'/new-request'} style={{color: "#ffffff", fontWeight: "500"}}>
          <EditOutlined style={{color: "#ffffff", fontSize: "1rem"}}/><span className="menu-item-link-name">Створення запиту</span>
        </Link>
      </Menu.Item>}
      {info?.data?.idm?.isNotary && <Menu.Item key={3} className='single-item link-main'>
        <Link to={'/request-list'} style={{color: "#ffffff", fontWeight: "500"}}>
          <BookOutlined style={{color: "#ffffff", fontSize: "1rem"}}/><span className="menu-item-link-name">Перегляд поданих запитів</span>
        </Link>
      </Menu.Item>}

      <Menu.Item key={4} className='single-item to-logout' onClick={handleLogout}>
        <PoweroffOutlined style={{color: "#ffffff", fontSize:"1rem"}}  />
        <span className="menu-item-link-name" >Вийти</span>
      </Menu.Item>
    </Menu>
  )
}

function mapStateToProps(state) {
  return{
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {

  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



